/* eslint-disable react/jsx-no-bind */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Select, Form } from 'antd';
import setCookie from '../util/setCookie';

const { Option } = Select;

// shippingCountry -> in common.js handles display none after button click
const LocationSwitcherModal = ({
  cancelAvailable,
  currencyPairs,
  defaultLanguage,
  defaultLocation,
  languages,
  links,
  locations,
  stringCancel,
  stringChoose,
  stringLanguage,
  stringLocation,
}) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current.setFieldsValue({
      location: defaultLocation,
      language: defaultLanguage,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleSubmit() {
    const language = ref.current.getFieldValue('language');
    const location = ref.current.getFieldValue('location');
    const currency = currencyPairs[location];
    setCookie('currency', currency, 365);
    setCookie('language', language, 365);
    setCookie('location', location, 365);
    // eslint-disable-next-line
    if (window.location.href !== links[language]) {
      // eslint-disable-next-line
      window.location.href = links[language];
    } else {
      // eslint-disable-next-line
      window.location.reload();
    }
  }

  return (
    <div className="location-select__wrapper">
      <div className="location-select__inputs">
        <Form layout="vertical" ref={ref}>
          <Form.Item name="location" label={stringLocation}>
            <Select>
              {Object.keys(locations)
                .sort()
                .map((location) => (
                  <Option value={location}>{locations[location]}</Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name="language" label={stringLanguage}>
            <Select>
              {Object.keys(languages).map((language) => (
                <Option value={languages[language].slug}>
                  {languages[language].name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Button
            type="primary"
            id="select-location-select"
            htmlType="submit"
            onClick={handleSubmit}
            disabled={false}
          >
            {stringChoose}
          </Button>
          {cancelAvailable && (
            <Button type="secondary" id="select-location-cancel">
              {stringCancel}
            </Button>
          )}
        </Form>
      </div>
    </div>
  );
};

LocationSwitcherModal.propTypes = {
  cancelAvailable: PropTypes.bool.isRequired,
  currencyPairs: PropTypes.shape({}).isRequired,
  defaultLanguage: PropTypes.string.isRequired,
  defaultLocation: PropTypes.string.isRequired,
  languages: PropTypes.shape({}).isRequired,
  links: PropTypes.shape({}).isRequired,
  locations: PropTypes.shape({}).isRequired,
  stringCancel: PropTypes.string.isRequired,
  stringChoose: PropTypes.string.isRequired,
  stringLanguage: PropTypes.string.isRequired,
  stringLocation: PropTypes.string.isRequired,
};

export default LocationSwitcherModal;
